import styled from 'styled-components';

import Button from '../Button/Button';

export const WidgetWrapperStyled = styled.div`
  position: fixed;
  z-index: 2;
  bottom: 20px;
  right: 20px;
`;

export const WidgetButtonStyled = styled(Button)`
  width: 50px;
  height: 50px;
  border-radius: 50%;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const WidgetRowStyled = styled.li`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 10px;
  gap: 10px;
`;

export const TextStyled = styled.span`
  flex: none;

  ${({ theme }) => `
    border: solid 1px ${theme.borderColour};
    background-color: ${theme.whiteColour};
    padding: 1px 10px;
    border-radius: 4px;
    box-shadow: 0px 3px 6px #00000029;
    color: ${theme.textColour};
  `}
`;
